import { Box, IconButton, Dialog, DialogTitle, TextField, Button } from '../../../ui/core';
import { CloseIcon } from '../../../ui/icons';
import { useForm, useFormState } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useToast } from '../../../hooks';
import { createVehicle, fetchVehicles } from '../../../redux/Fleet/actions';

const style = {
  fields: {
    padding: '32px',
    display: 'flex',
    gap: '16px',
    flexWrap: 'wrap',
    '.MuiTextField-root': { width: '250px' },
  },
};

const AddVehicleDialog = ({ onClose }) => {
  const dispatch = useDispatch();
  const t = useToast();

  const form = useForm({
    mode: 'onChange',
    defaultValues: {
      displayName: '',
      vin: '',
      make: '',
      model: '',
      year: '',
      notes: '',
    },
  });
  const { isDirty, isValid, isSubmitting } = useFormState({ control: form.control });

  const onSubmit = async (data) => {
    const input = {
      displayName: data.displayName,
      ...(data.vin && { vin: data.vin }),
      ...(data.make && { make: data.make }),
      ...(data.model && { model: data.model }),
      ...(data.year && { year: data.year }),
      ...(data.notes && { notes: data.notes }),
    };
    const { success } = await createVehicle(input)(dispatch);
    if (success) {
      t.success('Vehicle added');
      fetchVehicles()(dispatch);
      onClose();
    } else {
      t.error('Failed to add vehicle');
    }
  };

  return (
    <Dialog open onClose={onClose}>
      <Box display="flex" alignItems="center" justifyContent="space-between" padding="32px 32px 0 32px">
        <DialogTitle sx={{ padding: 0 }}>Add Fleet Vehicle</DialogTitle>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box component="form" onSubmit={form.handleSubmit(onSubmit)}>
        <Box sx={style.fields}>
          <TextField label="Display Name" control={form.control} name="displayName" rules={{ required: 'Required' }} />
          <TextField label="Make" control={form.control} name="make" />
          <TextField label="Model" control={form.control} name="model" />
          <TextField label="Year" control={form.control} name="year" />
          <TextField label="VIN" control={form.control} name="vin" />
          <TextField label="Notes" control={form.control} name="notes" sx={{ width: '100% !important' }} multiline rows={2} />
        </Box>
        <Button
          type="submit"
          disabled={!(isValid && isDirty)}
          loading={isSubmitting}
          variant="contained"
          size="large"
          disableElevation
          sx={{ width: '100%', padding: '20px', borderRadius: '0 0 4px 4px' }}
        >
          Save
        </Button>
      </Box>
    </Dialog>
  );
};

export default AddVehicleDialog;
